<template>
  <v-flex
    xs12
    class="px-2"
  >
    <div 
      class="expande-horizontal column"
      style="min-height: 80vh; max-height: 80vh;"
    >
      <Filters :filter="filter" />
      <List :onlyEmitInput="true" @input="e => $emit('input', e)" :filtereds="filtereds" />
      <EmptyList
        :iniciarCadastro="iniciarCadastro"
        v-if="filtereds.length === 0"
      />
      <v-spacer></v-spacer>
      <div class="expande-horizontal pl-1">
        <v-btn
          block
          dark
          rounded
          depressed
          color="blue"
          @click="iniciarCadastro"
        >
          Cadastrar aluno
        </v-btn>
      </div>
      <v-dialog
        transition="slide-x-transition"
        fullscreen
        :value="get_student._id || get_student.new ? true : false"
      >
        <v-card>
          <ViewForm />
        </v-card>
      </v-dialog>
    </div>
  </v-flex>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {},
      options: [
        {
          nome: "Novo student",
          action: this.iniciarCadastro,
          icon: "mdi-plus"
        }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "students",
          path: "/students"
        }
      ]
    };
  },
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm
  },
  computed: {
    ...mapGetters([
      "get_students_filtros",
      "getLoggedUser",
      "get_student",
      "get_students",
      "getPersonalizedLoading"
    ]),
    filtereds() {
      if (this.filter.search) {
        return this.get_students.docs.filter(item => {
          return (
            (item.nome &&
              item.nome
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.email &&
              item.email
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (item.telefone &&
              item.telefone.includes(this.filter.search.toLowerCase()))
          );
        });
      } else {
        return this.get_students.docs;
      }
    }
  },
  methods: {
    excluir_student_dialog(item) {
      let text = "Deseja remover este student?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_student",
        action_value: item
      });
    },
    getLinkById(id) {
      return this.getLinkById[id];
    },
    ...mapActions([
      "abre_modal_view_tenant",
      "listar_tenants",
      "listar_students",
      "criar_estoque",
      "listar_studentcategorias",
      "criar_student",
      "listar_estoques",
      "atualizar_student",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
    criarOuAtualizar() {
      if (this.get_student._id) {
        this.atualizar_student();
      } else {
        this.criar_student();
      }
    },
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_student", { new: true });
      this.$store.commit("setLinks", []);
      this.setPersonalizedLoading("animate__fadeInUp");
    },
    createOrUpdate() {
      if (this.$refs.form.validate()) {
        if (this.get_student._id) {
          this.atualizar_student();
        } else {
          this.criar_student();
        }
      }
    }
  },
  created() {
    this.listar_students();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
